import React from "react";
import { Button } from "antd";

const variantStyles = {
  primary: [
    "!bg-[#910e11]",
    "!border-0",
    "!text-white",
    "hover:!bg-[#910e11]",
    "hover:!border-0",
    "hover:!text-white",
  ].join(" "),

  outlined: [
    "!bg-white",
    "!border-2",
    "!border-[#910e11]",
    "!text-[#910e11]",
    "hover:!bg-white",
    "hover:!border-2",
    "hover:!border-[#910e11]",
    "hover:!text-[#910e11]",
  ].join(" "),
};

const baseStyles = [
  "!h-[2.86rem]",
  "!W-[18.25rem]" ,
  "!rounded-[0.625rem]",
  "!font-medium", 
  "!px-[1.25rem]", 
  "disabled:!bg-[#E8E8E8]",
  "disabled:!text-[#5D5D5D]", 
  "disabled:!border-[#E8E8E8]",
  "disabled:!cursor-not-allowed",
  "disabled:!shadow-none",
  "disabled:!opacity-100",
].join(" ");

const CustomButton = ({
  variant = "primary",
  className = "",
  children,
  onClick,
  ...props
}) => {
  return (
    <Button
      onClick={onClick}
      className={`${baseStyles} ${variantStyles[variant] ?? ""} ${className}`}
      {...props}
    >
      {children}
    </Button>
  );
};

export default CustomButton;